import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Label } from "reactstrap";
import { Formik, Form, Field } from "formik";
import "../organization.css";
import { ButtonWithSpinner } from "../../../../../components/common";
import { loginSelector, loadingSelector } from "../../../selectors";
import { Input } from "../../../../../components/formik";
import { withError } from "../../../../../components/hocs";
import {
  getOrganizationLogin,
  updateOrganizationLogin,
} from "../../../actions";
import FullscreenLoader from "../../../../../layouts/FullScreenLoader";

const OrganizationLoginPage = () => {
  const ErrorInput = withError(Input);
  const organizationLogin = useSelector(loginSelector);
  const loading = useSelector(loadingSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrganizationLogin());
  }, [loadingSelector]);

  const handleSubmit = (data) => {
    dispatch(updateOrganizationLogin(data));
  };

  return (
    <React.Fragment>
      <FullscreenLoader loading={loading} />
      <Container
        style={{ opacity: loading ? 0 : 1 }}
        className="mt-5 col-10"
        tabIndex="0"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            document
              .getElementById("searchClientProfileEntriesSubmitButton")
              .click();
          }
        }}
      >
        <Formik
          onSubmit={handleSubmit}
          enableReinitialize
          initialValues={{
            domainMatchInput:
              organizationLogin && organizationLogin.length > 0
                ? organizationLogin[0].loginDomainMatchEntries
                    .filter((a) => a.loginDomainMatchEntryType === 0)
                    .map((a) => a.name)
                    .join(";")
                : "",
            emailDomainMatchInput:
              organizationLogin && organizationLogin.length > 0
                ? organizationLogin[0].loginDomainMatchEntries
                    .filter((a) => a.loginDomainMatchEntryType === 1)
                    .map((a) => a.name)
                    .join(";")
                : "",
          }}
        >
          {({ errors }) => (
            <Form className="search-monitoring-queue-entries-form">
              <Row>
                <Col lg={6}>
                  <Label>Domain entry match</Label>
                  <Field
                    name="domainMatchInput"
                    placeholder="Domain entry match"
                    component={ErrorInput}
                  />
                </Col>
                <Col lg={6}>
                  <Label>Email domain entry match</Label>
                  <Field
                    name="emailDomainMatchInput"
                    placeholder="Email domain entry match"
                    component={ErrorInput}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col lg={8}>
                  {errors.atLeastOneOf && (
                    <React.Fragment>
                      <div className="form-error-message">
                        {errors.atLeastOneOf}
                      </div>
                    </React.Fragment>
                  )}
                </Col>
                <Col lg={4}>
                  <ButtonWithSpinner
                    id="searchClientProfileEntriesSubmitButton"
                    text="Save"
                    outline
                    type="submit"
                    className="float-right save-button"
                    loading={loading}
                  />
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Container>
    </React.Fragment>
  );
};
export default OrganizationLoginPage;



// WEBPACK FOOTER //
// ./src/features/organization/pages/settings/organization-login/OrganizationLoginPage.jsx